import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { CHECKOUT_STATUS } from '../../models/Checkout';
import { CheckoutCard, BUTTON_TYPES } from '../../common/checkout-card';
import { WindowHelper } from '../../helpers/WindowHelper';
import { HomeNavbar } from '../../common/home-navbar';
import { CheckoutStore } from '../../stores/CheckoutStore';
import { Spinner } from '../../common/spinner';
import { ParamsHelper } from '../../helpers/ParamsHelper';
import styles from './CheckoutBankSummary.css';

const IPropTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

class CheckoutBankSummary extends React.Component {
  constructor(props) {
    super(props);
    const { transaction } = ParamsHelper.parseQueryParams(props.location.search);
    this.state = {
      error: null,
      transaction: transaction || localStorage.getItem('last_transaction_bank'),
    };
    this.buttonBank = React.createRef();
    this._printPage = this._printPage.bind(this);
    this._loadInfoCheckout = this._loadInfoCheckout.bind(this);
    this._loadPrevInfo = this._loadPrevInfo.bind(this);
    localStorage.removeItem('last_transaction_bank');
  }

  componentDidMount() {
    setTimeout(() => {
      this._loadPrevInfo();
    }, 7000);
    this._loadInfoCheckout();
  }

  async _loadPrevInfo() {
    if (this.state.transaction) {
      try {
        await CheckoutStore.getStatusCheckout(this.state.transaction);
      } catch (error) {
        this.setState({ error: error.message });
      }
    } else {
      this.setState({ error: 'No existe el identificador de la transacción' });
    }
  }

  async _loadInfoCheckout() {
    if (this.state.transaction) {
      try {
        await CheckoutStore.getCheckout(this.state.transaction);
      } catch (error) {
        this.setState({ error: error.message });
      }
    } else {
      this.setState({ error: 'No existe el identificador de la transacción' });
    }
  }

  _printPage(_, buttonType) {
    if (buttonType === BUTTON_TYPES.PRINT) {
      console.log(this);
      WindowHelper.print();
    }
  }

  render() {
    const buttonTypes = [];
    if (CheckoutStore.checkout && CheckoutStore.checkout.status === CHECKOUT_STATUS.CONFIRMED
      && WindowHelper.printEnabled()) {
      buttonTypes.push(BUTTON_TYPES.PRINT);
    }

    return (
      <div className={styles.container}>
        <HomeNavbar />
        <div className={styles.container}>
          <h1 className={styles.title}>
            Resumen de compra por banco
          </h1>
          {
            CheckoutStore.statusCheckout !== undefined && CheckoutStore.creationLoading
            && !CheckoutStore.creationStatusLoading
            && CheckoutStore.statusCheckout === true &&
            <div>
              <div>Recibimos el pago y tu pedido está confirmado.</div>
              <div>Estamos cargando los detalles de tu compra (esto puede tardar hasta 1 minuto).
                De lo contrario, podrás visualizar los detalles en <a href="/my-orders" style={{ color: '#028154' }}>Mis compras.</a>
              </div>
              <div>¡Gracias por tu confianza!</div>
            </div>
          }
          {
            CheckoutStore.statusCheckout !== undefined && CheckoutStore.creationLoading
            && !CheckoutStore.creationStatusLoading
            && CheckoutStore.statusCheckout === false &&
            <div>
              <div>Lamentamos que tu pago no haya podido ser realizado.</div>
              <div>Te invitamos a volver a agregar tus productos al carrito y
                probar realizar nuevamente el pago. <a href="/" style={{ color: '#028154' }}>Ir al inicio</a>.
              </div>
              <div>¡Gracias por tu confianza!</div>
            </div>
          }
          {
            CheckoutStore.creationLoading &&
            <Spinner className={styles.spinner} />
          }
          {
            CheckoutStore.checkout ?
              <CheckoutCard
                isPageMyShoppins={false}
                buttonTypes={buttonTypes}
                className={styles.checkoutCard}
                checkout={CheckoutStore.checkout}
                onButtonClick={this._printPage}
              /> :
              <p className={styles.error}>{this.state.error}</p>
          }
          {
            CheckoutStore.getError &&
            <p className={styles.error}>{String(CheckoutStore.getError.message)}</p>
          }
        </div>
      </div>
    );
  }
}

CheckoutBankSummary.propTypes = IPropTypes;

const ObservedCheckoutBankSummary = observer(CheckoutBankSummary);

export { ObservedCheckoutBankSummary as CheckoutBankSummary };



// WEBPACK FOOTER //
// ./src/pages/checkout-bank-summary/CheckoutBankSummary.jsx